function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M61,2H3A1,1,0,0,0,2,3V61a1,1,0,0,0,1,1H61a1,1,0,0,0,1-1V3A1,1,0,0,0,61,2ZM60,20H56.72a2,2,0,1,0,0,2H60V60H4V4H60Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47,25a1,1,0,0,0,1-1V21a1,1,0,0,0-1-1H45a1,1,0,0,0-1-1V17a1,1,0,0,0-1-1H40a1,1,0,0,0-1,1v2H38V17a1,1,0,0,0-1-1H34a1,1,0,0,0-1,1v2H31V17a1,1,0,0,0-1-1H27a1,1,0,0,0-1,1v2H25V17a1,1,0,0,0-1-1H21a1,1,0,0,0-1,1v2a1,1,0,0,0-1,1H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h2v1H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h2v2H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h2v1H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h2a1,1,0,0,0,1,1v2a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V45h1v2a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V45h2v2a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V45h1v2a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V45a1,1,0,0,0,1-1h2a1,1,0,0,0,1-1V40a1,1,0,0,0-1-1H45V38h2a1,1,0,0,0,1-1V34a1,1,0,0,0-1-1H45V31h2a1,1,0,0,0,1-1V27a1,1,0,0,0-1-1H45V25Zm-2-3h1v1H45ZM19,42H18V41h1Zm0-6H18V35h1Zm0-7H18V28h1Zm0-6H18V22h1Zm22-5h1v1H41Zm-6,0h1v1H35Zm-7,0h1v1H28Zm-6,0h1v1H22Zm1,28H22V45h1Zm6,0H28V45h1Zm7,0H35V45h1Zm6,0H41V45h1Zm1-3H21V21H43Zm3-2v1H45V41Zm0-6v1H45V35Zm0-7v1H45V28Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M47,10h8a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H47a1,1,0,0,0-1,1V9A1,1,0,0,0,47,10Zm1-3h6V8H48Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47,16h8a1,1,0,0,0,1-1V12a1,1,0,0,0-1-1H47a1,1,0,0,0-1,1v3A1,1,0,0,0,47,16Zm1-3h6v1H48Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5,24a3,3,0,1,0,4-2.816V10.816a3,3,0,1,0-2,0V21.184A3,3,0,0,0,5,24Zm3,1a1,1,0,1,1,1-1A1,1,0,0,1,8,25ZM8,7A1,1,0,1,1,7,8,1,1,0,0,1,8,7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,53a3,3,0,0,0-2.816,2H10.535L9,52.7V49.816a3,3,0,1,0-2,0V53a1.006,1.006,0,0,0,.168.555l2,3A1,1,0,0,0,10,57h3.184A2.995,2.995,0,1,0,16,53ZM8,46a1,1,0,1,1-1,1A1,1,0,0,1,8,46Zm8,11a1,1,0,1,1,1-1A1,1,0,0,1,16,57Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56,53a1.993,1.993,0,0,0-1.722,1h-1.42A4,4,0,0,0,49,51H41a4,4,0,0,0-3.858,3h-1.42a2,2,0,1,0,0,2h1.42A4,4,0,0,0,41,59h8a4,4,0,0,0,3.858-3h1.42A2,2,0,1,0,56,53Zm-7,4H41a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54,35.722V45H52.722a2,2,0,1,0,0,2H55a1,1,0,0,0,1-1V35.722a2,2,0,1,0-2,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,15h4a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v8A1,1,0,0,0,14,15Zm1-8h2v6H15Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,10a1.993,1.993,0,0,0,1.722-1h7.556a2,2,0,1,0,0-2H25.722A2,2,0,1,0,24,10Z"
}));

var SvgEsc = function SvgEsc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEsc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/esc.d70f99b0.svg";
export { ForwardRef as ReactComponent };